import { createContext } from 'react'

// Context
const SubmissionContext = createContext({
  submitting: {
    inProgress: false,
    remainingRetries: 3,
    failedState: null,
    slow: false,
  },
  updateSubmitting: (status: any, error: string) => {},
  error: null,
  submit: (formData: any) => {},
  getStatus: (formData: any) => {},
  postAdditionalDetails: (claimId: string, signature: string, information: any) => {},
  getClaimInformationRequests: (formData: { claimId: string }) => {},
  campaignId: '',
  sessionId: '',
  submissionUri: '',
  qualifiedPromoLinks: '',
})

export default SubmissionContext
